export default __webpack_public_path__ + "static/media/like.ddd8d194.svg";